import { VueConstructor } from 'vue';
import { Store } from 'vuex';
import useFeaturesStore from '@/common/store/pinia/features';

export function featureStorePlugin(Vue: VueConstructor<Vue>): (store: Store<RootState>) => void {
  return (store) => {
    store.$featureOn = function (featureName) {
      return Vue.prototype.$featureOn.call({ $store: this }, featureName);
    };
  };
}

export default function featuresPlugin(Vue, pinia) {
  let enabledFeatures = {};
  const featuresStore = useFeaturesStore(pinia);

  if (typeof window !== 'undefined') {
    try {
      const features = window.localStorage.getItem('features');
      enabledFeatures = JSON.parse(features as string) || {};
    } catch (e) {
      console.error('Not valid JSON string was set to the `feature` key of localStorage: ', e);
      enabledFeatures = {};
    }
  }

  Vue.prototype.$featureOn = function (feature: string): boolean {
    const featureConfig = featuresStore.findFeature(feature);

    if (!featureConfig) {
      console.error(`Unknown featureId "${feature}" is used.`);
      return false;
    }

    return typeof enabledFeatures[feature] === 'boolean'
      ? enabledFeatures[feature]
      : featureConfig.enabled;
  };

  featuresStore.fetchItems();
}
